import recurrenceMasterOperations from './recurrenceMasterOperations';
import bookForOperations from './bookForOperations';
import attendeesOperations from './attendeesOperations';

export default {
  ...recurrenceMasterOperations,
  ...bookForOperations,
  ...attendeesOperations
};
